export enum UpgradePricePlan {
	Pro = 'Pro',
	Enterprise = 'Enterprise',
	Basic = 'Basic'
}